import React, { useState, useEffect } from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import DfpAd from "../../dfp-ad";

const InterstitialAd = ({ lang, pageType, collectionName }) => {
  const [isInterstitialAd, setInterstitialAd] = useState(true);

  useEffect(() => {
    setInterstitialAd(true);
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth-uat.prothomalo"))
    ) {
      setInterstitialAd(false);
    }
  });

  useEffect(() => {
    setInterstitialAd(false);
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth-uat.prothomalo"))
    ) {
      setInterstitialAd(false);
    }
  }, [pageType]);

  useEffect(() => {
    if (collectionName) {
      setInterstitialAd(false);
    }
  }, [collectionName]);

  const getAdType = () => {
    if (lang === "en") {
      if (pageType === "home-page") {
        return "EnPalo_HP_Int_660x440";
      } else {
        return "EnPalo_Inner_Int_660x440";
      }
    } else {
      if (pageType === "home-page") {
        return "home_Int_660x440";
      } else {
        return "News_Int_660x440";
      }
    }
  };

  if (!isInterstitialAd) {
    return null;
  }

  return isInterstitialAd ? <DfpAd adtype={getAdType()} slotId="interstial-ad" /> : null;
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "en"),
  pageType: get(state, ["qt", "pageType"], ""),
  collectionName: get(state, ["qt", "data", "collection", "name"], ""),
});

InterstitialAd.propTypes = {
  lang: string,
  pageType: string,
  collectionName: string,
};

export default connect(mapStateToProps, null)(InterstitialAd);
